export interface SpacingInterface {
  base: number
  stack: {
    big: string
    medium: string
    small: string
    x: {
      big: string
      medium: string
      small: string
    }
    xx: {
      big: string
      medium: string
    }
  }
  inline: {
    big: string
    medium: string
    small: string
    x: {
      big: string
      medium: string
      small: string
    }
    xx: {
      big: string
      medium: string
    }
  }
  padding: {
    height: {
      xbig: string
      big: string
      medium: string
      small: string
    }
    lenght: {
      xbig: string
      big: string
      medium: string
      small: string
      xsmall: string
    }
  }
}

export const spacing: SpacingInterface = {
  base: 5,
  inline: {
    big: '30px',
    medium: '15px',
    small: '10px',
    x: {
      big: '40px',
      medium: '20px',
      small: '5px',
    },
    xx: {
      big: '50px',
      medium: '25px',
    },
  },
  padding: {
    height: {
      big: '20px',
      medium: '15px',
      small: '10px',
      xbig: '30px',
    },
    lenght: {
      big: '30px',
      medium: '20px',
      small: '15px',
      xbig: '40px',
      xsmall: '10px',
    },
  },
  stack: {
    big: '30px',
    medium: '15px',
    small: '10px',
    x: {
      big: '40px',
      medium: '20px',
      small: '5px',
    },
    xx: {
      big: '50px',
      medium: '25px',
    },
  },
}
